import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTimer } from 'react-timer-hook';
import styles from './TimerV2.css';

const cx = classnames.bind(styles);

function TimerV2({ expiryTimestamp, className, onExpire, withPromo, label, withDiscount, minutesLabel = 'min', secondsLabel = 'sec' }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className),
        withPromo
    });
    const { minutes, isRunning, seconds } = useTimer({ expiryTimestamp, onExpire });

    if (!isRunning || !expiryTimestamp) {
        return null;
    }

    if (withDiscount) {
        return (
            <span className={styles.text} role='timer'>
                <strong>{minutes < 10 ? '0' : ''}{minutes}:{seconds < 10 ? '0' : ''}{seconds}</strong> {minutesLabel}
            </span>
        );
    }

    if (label) {
        return (
            <div className={styles.container}>
                <span className={styles.label}>{label}</span>
                <div className={classes} role='timer'>
                    <span><strong>{minutes < 10 ? '0' : ''}{minutes}</strong><br />{minutesLabel}</span>
                    <span className={styles.separator}>:</span>
                    <span><strong>{seconds < 10 ? '0' : ''}{seconds}</strong><br />{secondsLabel}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={classes} role='timer'>
            <span><strong>{minutes < 10 ? '0' : ''}{minutes}</strong><br />{minutesLabel}</span>
            <span className={styles.separator}>:</span>
            <span><strong>{seconds < 10 ? '0' : ''}{seconds}</strong><br />{secondsLabel}</span>
        </div>
    );
}

TimerV2.propTypes = {
    expiryTimestamp: PropTypes.any,
    className: PropTypes.string,
    onExpire: PropTypes.func,
    withPromo: PropTypes.bool,
    label: PropTypes.string,
    minutesLabel: PropTypes.string,
    secondsLabel: PropTypes.string
};

TimerV2.defaultProps = {
    className: '',
    onExpire: () => {},
    withPromo: false
};

export {
    TimerV2
};
